import { createStore, applyMiddleware, compose } from 'redux';

import apiMiddleWare from './middleware/api';
import rootReducer from './rootReducer';
import createSagaMiddleware, { END } from 'redux-saga';
const sagaMiddleware = createSagaMiddleware();

export default function (initialState, middleware) {
    const store = createStore(rootReducer, initialState,
        compose(
            applyMiddleware(
                middleware,
                apiMiddleWare,
                sagaMiddleware)));
    store.runSaga = sagaMiddleware.run;
    store.close = () => store.dispatch(END);
    return store;
}


// WEBPACK FOOTER //
// ./src/Store.js